import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: "",
        phone: "",
        landlordPhone: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCrossBorderOrderList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
              _this2.tableData = _this2.tableData.map(function (item) {
                var _item$houseUser, _item$user;
                return _objectSpread(_objectSpread({}, item), {}, {
                  userId: ((_item$houseUser = item.houseUser) === null || _item$houseUser === void 0 ? void 0 : _item$houseUser.id) || '',
                  otherId: ((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.id) || ''
                });
              });
              _this2.getUserListByIds(_this2.tableData, "userId", "otherId");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};